import {
  createService as publicCreateService,
  bulkCreateServices as publicBulkCreateServices,
  getService as publicGetService,
  updateService as publicUpdateService,
  bulkUpdateServices as publicBulkUpdateServices,
  bulkUpdateServicesByFilter as publicBulkUpdateServicesByFilter,
  deleteService as publicDeleteService,
  bulkDeleteServices as publicBulkDeleteServices,
  bulkDeleteServicesByFilter as publicBulkDeleteServicesByFilter,
  queryServices as publicQueryServices,
  typedQueryServices as publicTypedQueryServices,
  searchServices as publicSearchServices,
  queryPolicies as publicQueryPolicies,
  queryBookingForms as publicQueryBookingForms,
  countServices as publicCountServices,
  queryLocations as publicQueryLocations,
  queryCategories as publicQueryCategories,
  setServiceLocations as publicSetServiceLocations,
  enablePricingPlansForService as publicEnablePricingPlansForService,
  disablePricingPlansForService as publicDisablePricingPlansForService,
  setCustomSlug as publicSetCustomSlug,
  validateSlug as publicValidateSlug,
  cloneService as publicCloneService,
  createAddOnGroup as publicCreateAddOnGroup,
  deleteAddOnGroup as publicDeleteAddOnGroup,
  updateAddOnGroup as publicUpdateAddOnGroup,
  listAddOnGroupsByServiceId as publicListAddOnGroupsByServiceId,
  setAddOnsForGroup as publicSetAddOnsForGroup,
} from './bookings-services-v2-service-services.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryServicesOptions,
  ServiceQuery,
  ServicesQueryBuilder,
  typedQueryServices as universalTypedQueryServices,
} from './bookings-services-v2-service-services.universal.js';
import { onServiceCreated as publicOnServiceCreated } from './bookings-services-v2-service-services.public.js';
import { onServiceDeleted as publicOnServiceDeleted } from './bookings-services-v2-service-services.public.js';
import { onServiceUpdated as publicOnServiceUpdated } from './bookings-services-v2-service-services.public.js';

function customQueryServices(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryServicesOptions) =>
      publicQueryServices(httpClient)(options),
    typedQueryFunction: (query: ServiceQuery, options?: QueryServicesOptions) =>
      publicTypedQueryServices(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: ServiceQuery,
    options?: QueryServicesOptions
  ): ReturnType<typeof universalTypedQueryServices>;
  function overloadedQuery(
    options?: QueryServicesOptions
  ): ServicesQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: ServiceQuery | QueryServicesOptions,
    options?: QueryServicesOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createService: MaybeContext<
  BuildRESTFunction<typeof publicCreateService> & typeof publicCreateService
> = /*#__PURE__*/ createRESTModule(publicCreateService);
export const bulkCreateServices: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateServices> &
    typeof publicBulkCreateServices
> = /*#__PURE__*/ createRESTModule(publicBulkCreateServices);
export const getService: MaybeContext<
  BuildRESTFunction<typeof publicGetService> & typeof publicGetService
> = /*#__PURE__*/ createRESTModule(publicGetService);
export const updateService: MaybeContext<
  BuildRESTFunction<typeof publicUpdateService> & typeof publicUpdateService
> = /*#__PURE__*/ createRESTModule(publicUpdateService);
export const bulkUpdateServices: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateServices> &
    typeof publicBulkUpdateServices
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateServices);
export const bulkUpdateServicesByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateServicesByFilter> &
    typeof publicBulkUpdateServicesByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateServicesByFilter);
export const deleteService: MaybeContext<
  BuildRESTFunction<typeof publicDeleteService> & typeof publicDeleteService
> = /*#__PURE__*/ createRESTModule(publicDeleteService);
export const bulkDeleteServices: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteServices> &
    typeof publicBulkDeleteServices
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteServices);
export const bulkDeleteServicesByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteServicesByFilter> &
    typeof publicBulkDeleteServicesByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteServicesByFilter);
export const searchServices: MaybeContext<
  BuildRESTFunction<typeof publicSearchServices> & typeof publicSearchServices
> = /*#__PURE__*/ createRESTModule(publicSearchServices);
export const queryPolicies: MaybeContext<
  BuildRESTFunction<typeof publicQueryPolicies> & typeof publicQueryPolicies
> = /*#__PURE__*/ createRESTModule(publicQueryPolicies);
export const queryBookingForms: MaybeContext<
  BuildRESTFunction<typeof publicQueryBookingForms> &
    typeof publicQueryBookingForms
> = /*#__PURE__*/ createRESTModule(publicQueryBookingForms);
export const countServices: MaybeContext<
  BuildRESTFunction<typeof publicCountServices> & typeof publicCountServices
> = /*#__PURE__*/ createRESTModule(publicCountServices);
export const queryLocations: MaybeContext<
  BuildRESTFunction<typeof publicQueryLocations> & typeof publicQueryLocations
> = /*#__PURE__*/ createRESTModule(publicQueryLocations);
export const queryCategories: MaybeContext<
  BuildRESTFunction<typeof publicQueryCategories> & typeof publicQueryCategories
> = /*#__PURE__*/ createRESTModule(publicQueryCategories);
export const setServiceLocations: MaybeContext<
  BuildRESTFunction<typeof publicSetServiceLocations> &
    typeof publicSetServiceLocations
> = /*#__PURE__*/ createRESTModule(publicSetServiceLocations);
export const enablePricingPlansForService: MaybeContext<
  BuildRESTFunction<typeof publicEnablePricingPlansForService> &
    typeof publicEnablePricingPlansForService
> = /*#__PURE__*/ createRESTModule(publicEnablePricingPlansForService);
export const disablePricingPlansForService: MaybeContext<
  BuildRESTFunction<typeof publicDisablePricingPlansForService> &
    typeof publicDisablePricingPlansForService
> = /*#__PURE__*/ createRESTModule(publicDisablePricingPlansForService);
export const setCustomSlug: MaybeContext<
  BuildRESTFunction<typeof publicSetCustomSlug> & typeof publicSetCustomSlug
> = /*#__PURE__*/ createRESTModule(publicSetCustomSlug);
export const validateSlug: MaybeContext<
  BuildRESTFunction<typeof publicValidateSlug> & typeof publicValidateSlug
> = /*#__PURE__*/ createRESTModule(publicValidateSlug);
export const cloneService: MaybeContext<
  BuildRESTFunction<typeof publicCloneService> & typeof publicCloneService
> = /*#__PURE__*/ createRESTModule(publicCloneService);
export const createAddOnGroup: MaybeContext<
  BuildRESTFunction<typeof publicCreateAddOnGroup> &
    typeof publicCreateAddOnGroup
> = /*#__PURE__*/ createRESTModule(publicCreateAddOnGroup);
export const deleteAddOnGroup: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAddOnGroup> &
    typeof publicDeleteAddOnGroup
> = /*#__PURE__*/ createRESTModule(publicDeleteAddOnGroup);
export const updateAddOnGroup: MaybeContext<
  BuildRESTFunction<typeof publicUpdateAddOnGroup> &
    typeof publicUpdateAddOnGroup
> = /*#__PURE__*/ createRESTModule(publicUpdateAddOnGroup);
export const listAddOnGroupsByServiceId: MaybeContext<
  BuildRESTFunction<typeof publicListAddOnGroupsByServiceId> &
    typeof publicListAddOnGroupsByServiceId
> = /*#__PURE__*/ createRESTModule(publicListAddOnGroupsByServiceId);
export const setAddOnsForGroup: MaybeContext<
  BuildRESTFunction<typeof publicSetAddOnsForGroup> &
    typeof publicSetAddOnsForGroup
> = /*#__PURE__*/ createRESTModule(publicSetAddOnsForGroup);
export const queryServices: MaybeContext<
  BuildRESTFunction<typeof customQueryServices> & typeof customQueryServices
> = /*#__PURE__*/ createRESTModule(customQueryServices);
/**
 * Triggered when a service is created.
 */
export const onServiceCreated: BuildEventDefinition<
  typeof publicOnServiceCreated
> &
  typeof publicOnServiceCreated = createEventModule(publicOnServiceCreated);
/**
 * Triggered when a service is deleted.
 */
export const onServiceDeleted: BuildEventDefinition<
  typeof publicOnServiceDeleted
> &
  typeof publicOnServiceDeleted = createEventModule(publicOnServiceDeleted);
/**
 * Triggered when a service is updated.
 */
export const onServiceUpdated: BuildEventDefinition<
  typeof publicOnServiceUpdated
> &
  typeof publicOnServiceUpdated = createEventModule(publicOnServiceUpdated);

export {
  ServiceType,
  RateType,
  FrequencyType,
  FirstChargeDateType,
  AddOnPaymentOptions,
  LocationTypeEnumLocationType,
  RankingOrder,
  SortingMethodType,
  Timing,
  CompletionRequirement,
  TaxableAddressType,
  MultiServiceBookingType,
  ResourceTransparency,
  LocationType,
  SelectionMethod,
  ValueType,
  BookingStatus,
  PaymentStatus,
  SelectedPaymentOption,
  Platform,
  Actor,
  IdentityType,
  WebhookIdentityType,
  V2RequestedFields,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
  RequestedFields,
  Action,
  InvalidSlugError,
  CloneErrors,
  Status,
  CategoryNotificationEvent,
  BenefitType,
  Event,
  CrudType,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
} from './bookings-services-v2-service-services.universal.js';
export {
  Service,
  Media,
  MediaItem,
  MediaItemItemOneOf,
  V2Category,
  Form,
  FormSettings,
  Payment,
  PaymentRateOneOf,
  FixedPayment,
  Money,
  CustomPayment,
  VariedPayment,
  SubscriptionPayment,
  FullUpfrontPayment,
  PaymentOptions,
  DiscountInfo,
  OnlineBooking,
  Conferencing,
  V2Location,
  V2LocationOptionsOneOf,
  CommonAddress,
  CommonAddressStreetOneOf,
  CommonStreetAddress,
  CommonAddressLocation,
  BusinessLocationOptions,
  CustomLocationOptions,
  BookingPolicy,
  PolicyDescription,
  LimitEarlyBookingPolicy,
  LimitLateBookingPolicy,
  BookAfterStartPolicy,
  CancellationPolicy,
  ReschedulePolicy,
  WaitlistPolicy,
  ParticipantsPolicy,
  ResourcesPolicy,
  CancellationFeePolicy,
  CancellationWindow,
  CancellationWindowFeeOneOf,
  SaveCreditCardPolicy,
  StaffSortingPolicy,
  StaffSortingPolicyOptionsOneOf,
  RankingOptions,
  CustomOptions,
  IntakeFormPolicy,
  Schedule,
  AvailabilityConstraints,
  V2Duration,
  StaffMember,
  StaffMediaItem,
  StaffMediaItemItemOneOf,
  StaffMemberDetails,
  ResourceGroup,
  ResourceIds,
  ServiceResource,
  ServiceResourceSelectionOneOf,
  ResourceType,
  Slug,
  URLs,
  ExtendedFields,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  AddOnGroup,
  AddOnDetails,
  TaxableAddress,
  V2PhoneCall,
  SetCustomSlugEvent,
  ServicesUrlsChanged,
  DummyRequest,
  DummyResponse,
  Booking,
  BookingParticipantsInfoOneOf,
  BookedEntity,
  BookedEntityItemOneOf,
  BookedSlot,
  BookedResource,
  Location,
  PhoneCall,
  ResourceSelection,
  BookedSchedule,
  ContactDetails,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  CustomFormField,
  BookingSource,
  ParticipantNotification,
  CommonIdentificationData,
  CommonIdentificationDataIdOneOf,
  FlowControlSettings,
  ParticipantChoices,
  ServiceChoices,
  ServiceChoice,
  ServiceChoiceChoiceOneOf,
  Duration,
  MultiServiceBookingInfo,
  BookedAddOn,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateServiceRequest,
  CreateServiceResponse,
  ValidateServiceRequest,
  ValidateServiceResponse,
  FieldViolation,
  BulkCreateServicesRequest,
  BulkCreateServicesResponse,
  BulkServiceResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetServiceRequest,
  GetServiceResponse,
  GetServiceAvailabilityConstraintsRequest,
  GetServiceAvailabilityConstraintsResponse,
  ServiceAvailabilityConstraints,
  SplitInterval,
  UpdateServiceRequest,
  UpdateServiceResponse,
  BulkUpdateServicesRequest,
  MaskedService,
  BulkUpdateServicesResponse,
  BulkUpdateServicesByFilterRequest,
  BulkUpdateServicesByFilterResponse,
  DeleteServiceRequest,
  V2ParticipantNotification,
  DeleteServiceResponse,
  BulkDeleteServicesRequest,
  BulkDeleteServicesResponse,
  BulkDeleteServicesByFilterRequest,
  BulkDeleteServicesByFilterResponse,
  QueryServicesRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryServicesResponse,
  PagingMetadataV2,
  Cursors,
  SearchServicesRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  SearchDetails,
  SearchServicesResponse,
  CursorPagingMetadata,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  ScalarDateResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResultsScalarDateResult,
  AggregationResults,
  AggregationResultsResultOneOf,
  QueryPoliciesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  QueryPoliciesResponse,
  BookingPolicyWithServices,
  QueryBookingFormsRequest,
  QueryBookingFormsResponse,
  BookingForm,
  FormDetails,
  ConnectedService,
  CountServicesRequest,
  CountServicesResponse,
  QueryLocationsRequest,
  QueryLocationsFilter,
  QueryLocationsResponse,
  BusinessLocations,
  CustomLocations,
  CustomerLocations,
  QueryCategoriesRequest,
  QueryCategoriesFilter,
  QueryCategoriesResponse,
  QueryServicesMultiLanguageRequest,
  QueryServicesMultiLanguageResponse,
  SetServiceLocationsRequest,
  RemovedLocationSessionsAction,
  RemovedLocationSessionsActionActionOptionsOneOf,
  MoveToNewLocationsOptions,
  SetServiceLocationsResponse,
  EnablePricingPlansForServiceRequest,
  PricingPlanSelection,
  EnablePricingPlansForServiceResponse,
  InvalidPricingPlan,
  DisablePricingPlansForServiceRequest,
  DisablePricingPlansForServiceResponse,
  SetCustomSlugRequest,
  SetCustomSlugResponse,
  ValidateSlugRequest,
  ValidateSlugResponse,
  CloneServiceRequest,
  CloneServiceResponse,
  CategoryNotification,
  Category,
  Empty,
  BenefitNotification,
  Benefit,
  EntryPass,
  Discount,
  DiscountDiscountOneOf,
  Behavior,
  BehaviorBehaviorOneOf,
  UserDomainInfoChangedEvent,
  HtmlSitePublished,
  Page,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  V4Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  SiteCreated,
  SiteCloned,
  CreateAddOnGroupRequest,
  CreateAddOnGroupResponse,
  DeleteAddOnGroupRequest,
  DeleteAddOnGroupResponse,
  UpdateAddOnGroupRequest,
  UpdateAddOnGroupResponse,
  ListAddOnGroupsByServiceIdRequest,
  ListAddOnGroupsByServiceIdResponse,
  AddOn,
  AddOnAddOnInfoOneOf,
  AddOnGroupDetail,
  SetAddOnsForGroupRequest,
  SetAddOnsForGroupResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ServiceCreatedEnvelope,
  ServiceDeletedEnvelope,
  ServiceUpdatedEnvelope,
  BulkCreateServicesOptions,
  UpdateService,
  BulkUpdateServicesOptions,
  BulkUpdateServicesByFilterOptions,
  DeleteServiceOptions,
  BulkDeleteServicesOptions,
  BulkDeleteServicesByFilterOptions,
  QueryServicesOptions,
  ServicesQueryResult,
  ServicesQueryBuilder,
  ServiceQuerySpec,
  ServiceSearchSpec,
  QueryBookingFormsOptions,
  CountServicesOptions,
  QueryLocationsOptions,
  QueryCategoriesOptions,
  SetServiceLocationsOptions,
  DisablePricingPlansForServiceOptions,
  SetCustomSlugOptions,
  ValidateSlugOptions,
  CreateAddOnGroupOptions,
  DeleteAddOnGroupOptions,
  UpdateAddOnGroupOptions,
  ListAddOnGroupsByServiceIdOptions,
  SetAddOnsForGroupOptions,
} from './bookings-services-v2-service-services.universal.js';
export { utils } from './bookings-services-v2-service-services.universal.js';
export {
  ServiceTypeWithLiterals,
  RateTypeWithLiterals,
  FrequencyTypeWithLiterals,
  FirstChargeDateTypeWithLiterals,
  AddOnPaymentOptionsWithLiterals,
  LocationTypeEnumLocationTypeWithLiterals,
  RankingOrderWithLiterals,
  SortingMethodTypeWithLiterals,
  TimingWithLiterals,
  CompletionRequirementWithLiterals,
  TaxableAddressTypeWithLiterals,
  MultiServiceBookingTypeWithLiterals,
  ResourceTransparencyWithLiterals,
  LocationTypeWithLiterals,
  SelectionMethodWithLiterals,
  ValueTypeWithLiterals,
  BookingStatusWithLiterals,
  PaymentStatusWithLiterals,
  SelectedPaymentOptionWithLiterals,
  PlatformWithLiterals,
  ActorWithLiterals,
  IdentityTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  V2RequestedFieldsWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  RequestedFieldsWithLiterals,
  ActionWithLiterals,
  InvalidSlugErrorWithLiterals,
  CloneErrorsWithLiterals,
  StatusWithLiterals,
  CategoryNotificationEventWithLiterals,
  BenefitTypeWithLiterals,
  EventWithLiterals,
  CrudTypeWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  CreateServiceValidationErrors,
  UpdateServiceValidationErrors,
  QueryBookingFormsApplicationErrors,
  EnablePricingPlansForServiceApplicationErrors,
  DisablePricingPlansForServiceApplicationErrors,
  SetCustomSlugApplicationErrors,
  SetCustomSlugValidationErrors,
  DeleteAddOnGroupApplicationErrors,
  UpdateAddOnGroupApplicationErrors,
  SetAddOnsForGroupApplicationErrors,
  CommonQueryWithEntityContext,
  ServiceQuery,
  CommonSearchWithEntityContext,
  ServiceSearch,
} from './bookings-services-v2-service-services.universal.js';
